import type { HanziConfig } from '../types'

type SerializedConfig = {
  c?: string
  w?: string
  g?: 'tian' | 'mi' | 'fang'
  tc?: number
  so?: 1 | 0
  tc2?: string
  lc?: string
  ps?: 'a4' | 'letter'
  ff?: 'wenkai' | 'songti' | 'youqu'
  sp?: 1 | 0
  im?: 'char' | 'word'
}

const STORAGE_KEY = 'zitie:config'

export function serializeConfig(config: HanziConfig): string {
  const params = new URLSearchParams()
  const s: SerializedConfig = {}

  if (config.chars && config.chars !== '我爱学习汉字') s.c = config.chars
  if (config.words && config.words.length > 0) s.w = config.words.join(',')
  if (config.gridType !== 'mi') s.g = config.gridType
  if (config.traceCount !== 3) s.tc = config.traceCount
  if (config.showStrokeOrder) s.so = 1
  if (config.traceColor !== '#E74C3C') s.tc2 = config.traceColor
  if (config.lineColor !== '#9E9E9E') s.lc = config.lineColor
  if (config.paperSize !== 'a4') s.ps = config.paperSize
  if (config.fontFamily !== 'wenkai') s.ff = config.fontFamily
  if (config.showPinyin) s.sp = 1
  if (config.inputMode !== 'char') s.im = config.inputMode

  Object.entries(s).forEach(([key, value]) => {
    if (value !== undefined) params.set(key, String(value))
  })

  return params.toString()
}

export function deserializeConfig(searchParams: URLSearchParams): Partial<HanziConfig> {
  const result: Partial<HanziConfig> = {}

  if (searchParams.has('c')) result.chars = searchParams.get('c') || ''
  if (searchParams.has('w')) {
    const wordsStr = searchParams.get('w') || ''
    result.words = wordsStr.split(',').filter(Boolean)
  }
  if (searchParams.has('g')) {
    const g = searchParams.get('g')
    if (g === 'tian' || g === 'mi' || g === 'fang') result.gridType = g
  }
  if (searchParams.has('tc')) result.traceCount = Number(searchParams.get('tc'))
  if (searchParams.has('so')) result.showStrokeOrder = searchParams.get('so') === '1'
  if (searchParams.has('tc2')) result.traceColor = searchParams.get('tc2') || undefined
  if (searchParams.has('lc')) result.lineColor = searchParams.get('lc') || undefined
  if (searchParams.has('ps')) {
    const ps = searchParams.get('ps')
    if (ps === 'a4' || ps === 'letter') result.paperSize = ps
  }
  if (searchParams.has('ff')) {
    const ff = searchParams.get('ff')
    if (ff === 'wenkai' || ff === 'songti' || ff === 'youqu') result.fontFamily = ff
  }
  if (searchParams.has('sp')) result.showPinyin = searchParams.get('sp') === '1'
  if (searchParams.has('im')) {
    const im = searchParams.get('im')
    if (im === 'char' || im === 'word') result.inputMode = im
  }

  return result
}

export function saveConfigToStorage(config: HanziConfig): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(config))
  } catch {
    // Storage may be full or unavailable
  }
}

export function loadConfigFromStorage(): Partial<HanziConfig> | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as Partial<HanziConfig>
  } catch {
    return null
  }
}

export function clearConfigStorage(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Ignore
  }
}
